'use client';
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import dynamic from "next/dynamic";
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false }) as any;


export default function VideoModal({ url, props }: any) {
    const [show, setModal] = useState(false);

    const handleClose = () => {
        setModal(false);
    };
    const handleOpen = () => {
        setModal(true);
    };
    return (
        <>
            {!show ?
                <div className="video-icon" onClick={()=>handleOpen()} >
                    <div className="video-vemo-icon venobox vbox-item" data-vbtype="youtube" data-autoplay="true"  ><i className="fa fa-play"></i></div>
                </div>
                :
                <Modal
                    {...props}
                    show={show}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header>
                        <Button variant="secondary" onClick={handleClose}>
                            X
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        {url ? <>
                            <ReactPlayer
                                url={url}
                                controls={true}
                                light={false}
                                pip={true}
                            />
                        </> : null}
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}